import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Icon, Text } from 'pcln-design-system'
import { capitalizeLetter } from '../../utils/string-helpers.js'

const WhyPricelineJustification = ({ iconName, headLine, subHeadLine }) => {
  iconName = capitalizeLetter(iconName)
  return (
    <Flex flexDirection={['row', 'column']} alignItems={['flex-start', 'center']}>
      <Icon name={iconName} size={28} color='primary' mr={[2, 0]} alt={iconName} title={iconName + ' icon'} titleId={iconName + '-id'} />
      <Flex flexDirection='column' width={1}>
        <Text mt={[0, 3]} fontWeight='bold' fontSize={[1, 2]} textAlign={['left', 'center']} caps>
          {headLine}
        </Text>
        <Text mt={['2px', 2]} fontSize={1} textAlign={['left', 'center']} color='text.light'>
          {subHeadLine}
        </Text>
      </Flex>
    </Flex>
  )
}

WhyPricelineJustification.propTypes = {
  iconName: PropTypes.string.isRequired,
  headLine: PropTypes.string.isRequired,
  subHeadLine: PropTypes.string.isRequired
}

export default WhyPricelineJustification
